module.exports = __webpack_public_path__ + "img/d023900fdb4616702d5c4e7811776e7e.svg";